import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { LGS_MODU } from '../lib/ortam';

const SISTEM = LGS_MODU ? 'LGS Soru Yazım Sistemi' : 'YKS Soru Üretim Sistemi';

export default function Login() {
  const { girisYap } = useAuth();
  const [email, setEmail] = useState('');
  const [sifre, setSifre] = useState('');
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHata('');
    setYukleniyor(true);

    try {
      await girisYap(email, sifre);
    } catch (err) {
      setHata(err.message || 'Giriş başarısız');
    }
    setYukleniyor(false);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-blue-700">{SISTEM}</h1>
          <p className="text-gray-500 text-sm mt-2">Giriş yaparak devam edin</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-semibold text-gray-600 mb-1">Kullanıcı adı veya e-posta</label>
            <input
              type="text" value={email} onChange={e => setEmail(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="TurUser veya ornek@makembed.fun" autoComplete="username" required
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-semibold text-gray-600 mb-1">Şifre</label>
            <input
              type="password" value={sifre} onChange={e => setSifre(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="********" required
            />
          </div>

          {hata && (
            <div className="mb-4 p-3 bg-red-50 border border-red-300 rounded-lg text-red-700 text-sm">
              {hata}
            </div>
          )}

          <button
            type="submit" disabled={yukleniyor}
            className="w-full py-3 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors"
          >
            {yukleniyor ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>

        <p className="text-center text-xs text-gray-400 mt-6">
          Esas Akademi — {LGS_MODU ? 'LGS Soru Yazım' : 'YKS Soru Üretim'} v3.1
        </p>
      </div>
    </div>
  );
}
